// tslint:disable:max-line-length

import React from 'react';

export const UtilityInfoOutline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <circle cx="8" cy="4.6" r="1.1" />
      <polygon points="8.9,6.7 6.2,6.7 6.2,8 7.1,8 7.1,11.1 6.2,11.1 6.2,12.5 9.8,12.5 9.8,11.1 8.9,11.1" />
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14.5c-3.6,0-6.5-2.9-6.5-6.5S4.4,1.5,8,1.5s6.5,2.9,6.5,6.5 S11.6,14.5,8,14.5z" />
    </svg>
  );
};
